export const embedsModule = {
  name: 'Embeds',
};
